// extracted by mini-css-extract-plugin
module.exports = {"fs-15":"_18llYXNInL3J5OUXAwDFw2"};